const form_validation = require("../form_validation");

const RANGES = [
  ["Moins de 300 €", 100],
  ["300 € à 1 000 €", 300],
  ["1 000 € à 5 000 €", 1000],
  ["5 000 € à 10 000 €", 5000],
  ["10 000 € à 50 000 €", 10000],
  ["50 000 € à 100 000 €", 50000],
  ["Plus de 100 000 €", 100000],
];

module.exports = function () {
  const $el = $("#bloc-onboarding"),
    $selectedRange = $el.find("#investment-capacity-range"),
    $input_range = $el.find("input[type=range]"),
    $radios = $el.find("input[name=horizon]"),
    $submit_button = $el.find("button[type=submit]"),
    $hidden_input = $el.find("#initial_amount");

  // Input range update

  $input_range.off("input change").on("input change", slider_state);

  $input_range.on("input", function (event) {
    const index = $(this).val();
    $selectedRange.html(RANGES[index][0]);
    $hidden_input.val(RANGES[index][1]);
  });

  // Override input range listener

  function slider_state() {
    $(this)
      .next()
      .css("width", $(this).val() * 16.67 + "%");
  }

  $input_range.trigger("input");

  // Horizon radios listener

  $radios.one("change", function () {
    $submit_button.removeAttr("disabled");
  });

  // Form validation

  function success_callback() {
    window.location = window.Anatec.constants.URLS.signup;
  }

  form_validation.handle($el.find("form"), success_callback);
};
